// src/constants/error-codes.ts
var AUTH_ERROR_CODES = {
  INVALID_CREDENTIALS: "AUTH_001",
  TOKEN_EXPIRED: "AUTH_002",
  TOKEN_INVALID: "AUTH_003",
  UNAUTHORIZED: "AUTH_004",
  REFRESH_TOKEN_INVALID: "AUTH_005",
  USER_ID_ALREADY_EXISTS: "AUTH_006",
  PASSWORD_TOO_WEAK: "AUTH_007",
  TOKEN_MISSING: "AUTH_012",
  INVALID_TOKEN: "AUTH_013",
  PERMISSION_DENIED: "AUTH_014"
};
var USER_ERROR_CODES = {
  USER_NOT_FOUND: "USER_001",
  USER_ALREADY_EXISTS: "USER_002",
  USER_ID_INVALID: "USER_003",
  USER_INACTIVE: "USER_004",
  PROFILE_UPDATE_FAILED: "USER_005",
  PROFILE_VALIDATION_FAILED: "USER_006",
  PROFILE_REQUIRED_FIELD_MISSING: "USER_007",
  PROFILE_SYNC_FAILED: "USER_008",
  PROFILE_DATA_INCONSISTENT: "USER_009"
};
var QUOTE_ERROR_CODES = {
  QUOTE_NOT_FOUND: "QUOTE_001",
  QUOTE_ACCESS_DENIED: "QUOTE_002",
  QUOTE_INVALID_STATUS: "QUOTE_003",
  QUOTE_CREATION_FAILED: "QUOTE_004",
  QUOTE_UPDATE_FAILED: "QUOTE_005",
  QUOTE_DELETION_FAILED: "QUOTE_006",
  QUOTE_REQUEST_NOT_FOUND: "QUOTE_007",
  QUOTE_RESPONSE_NOT_FOUND: "QUOTE_008",
  QUOTE_ALREADY_SUBMITTED: "QUOTE_009",
  QUOTE_ALREADY_RESPONDED: "QUOTE_010",
  DUPLICATE_RESPONSE: "QUOTE_011"
};
var PAYMENT_ERROR_CODES = {
  PAYMENT_NOT_FOUND: "PAYMENT_001",
  PAYMENT_ALREADY_PROCESSED: "PAYMENT_002",
  PAYMENT_INVALID_AMOUNT: "PAYMENT_003",
  PAYMENT_PROVIDER_ERROR: "PAYMENT_004",
  PAYMENT_CANCELLED: "PAYMENT_005",
  PAYMENT_FAILED: "PAYMENT_006",
  PAYMENT_TIMEOUT: "PAYMENT_007"
};
var STORAGE_ERROR_CODES = {
  FILE_NOT_FOUND: "STORAGE_001",
  FILE_UPLOAD_FAILED: "STORAGE_002",
  FILE_TOO_LARGE: "STORAGE_003",
  FILE_TYPE_NOT_ALLOWED: "STORAGE_004",
  FILE_DELETION_FAILED: "STORAGE_005",
  FILE_SIZE_EXCEEDED: "STORAGE_006"
};
var CHAT_ERROR_CODES = {
  CHAT_ROOM_NOT_FOUND: "CHAT_001",
  CHAT_MESSAGE_NOT_FOUND: "CHAT_002",
  CHAT_ACCESS_DENIED: "CHAT_003"
};
var CONTRACT_ERROR_CODES = {
  CONTRACT_NOT_FOUND: "CONTRACT_001",
  CONTRACT_ALREADY_EXISTS: "CONTRACT_002",
  CONTRACT_INVALID_STATUS: "CONTRACT_003",
  CONTRACT_CREATION_FAILED: "CONTRACT_004",
  CONTRACT_UPDATE_FAILED: "CONTRACT_005",
  CONTRACT_DELETION_FAILED: "CONTRACT_006",
  QUOTE_RESPONSE_ALREADY_CONTRACTED: "CONTRACT_007",
  INVALID_STATUS_TRANSITION: "CONTRACT_008",
  INSUFFICIENT_PERMISSIONS: "CONTRACT_009",
  CONTRACT_SIGNATURE_FAILED: "CONTRACT_010"
};
var VALIDATION_ERROR_CODES = {
  VALIDATION_FAILED: "VAL_001",
  REQUIRED_FIELD_MISSING: "VAL_002",
  INVALID_FORMAT: "VAL_003",
  INVALID_RANGE: "VAL_004"
};
var GENERAL_ERROR_CODES = {
  RESOURCE_NOT_FOUND: "GEN_001",
  CONFLICT_ERROR: "GEN_002",
  RESOURCE_LOCKED: "GEN_003"
};
var SYSTEM_ERROR_CODES = {
  INTERNAL_SERVER_ERROR: "SYS_001",
  SERVICE_UNAVAILABLE: "SYS_002",
  RATE_LIMIT_EXCEEDED: "SYS_003",
  TIMEOUT: "SYS_004",
  CONFIGURATION_ERROR: "SYS_005",
  UNKNOWN_ERROR: "SYS_006"
};
var ERROR_CODES = {
  ...AUTH_ERROR_CODES,
  ...USER_ERROR_CODES,
  ...QUOTE_ERROR_CODES,
  ...PAYMENT_ERROR_CODES,
  ...STORAGE_ERROR_CODES,
  ...CHAT_ERROR_CODES,
  ...CONTRACT_ERROR_CODES,
  ...VALIDATION_ERROR_CODES,
  ...GENERAL_ERROR_CODES,
  ...SYSTEM_ERROR_CODES
};
var ERROR_MESSAGES = {
  // Auth
  [AUTH_ERROR_CODES.INVALID_CREDENTIALS]: "\uC798\uBABB\uB41C \uC778\uC99D \uC815\uBCF4\uC785\uB2C8\uB2E4",
  [AUTH_ERROR_CODES.TOKEN_EXPIRED]: "\uD1A0\uD070\uC774 \uB9CC\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
  [AUTH_ERROR_CODES.TOKEN_INVALID]: "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uD1A0\uD070\uC785\uB2C8\uB2E4",
  [AUTH_ERROR_CODES.UNAUTHORIZED]: "\uC778\uC99D\uC774 \uD544\uC694\uD569\uB2C8\uB2E4",
  [AUTH_ERROR_CODES.PERMISSION_DENIED]: "\uAD8C\uD55C\uC774 \uC5C6\uC2B5\uB2C8\uB2E4",
  // User
  [USER_ERROR_CODES.USER_NOT_FOUND]: "\uC0AC\uC6A9\uC790\uB97C \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
  [USER_ERROR_CODES.USER_ALREADY_EXISTS]: "\uC774\uBBF8 \uC874\uC7AC\uD558\uB294 \uC0AC\uC6A9\uC790\uC785\uB2C8\uB2E4",
  [USER_ERROR_CODES.USER_INACTIVE]: "\uBE44\uD65C\uC131 \uC0AC\uC6A9\uC790\uC785\uB2C8\uB2E4",
  // Quote
  [QUOTE_ERROR_CODES.QUOTE_NOT_FOUND]: "\uACAC\uC801\uC744 \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
  [QUOTE_ERROR_CODES.QUOTE_ACCESS_DENIED]: "\uACAC\uC801\uC5D0 \uC811\uADFC\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
  [QUOTE_ERROR_CODES.QUOTE_REQUEST_NOT_FOUND]: "\uACAC\uC801 \uC694\uCCAD\uC744 \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
  [QUOTE_ERROR_CODES.QUOTE_RESPONSE_NOT_FOUND]: "\uACAC\uC801 \uC751\uB2F5\uC744 \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
  // Payment
  [PAYMENT_ERROR_CODES.PAYMENT_NOT_FOUND]: "\uACB0\uC81C \uC815\uBCF4\uB97C \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
  [PAYMENT_ERROR_CODES.PAYMENT_FAILED]: "\uACB0\uC81C\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4",
  [PAYMENT_ERROR_CODES.PAYMENT_CANCELLED]: "\uACB0\uC81C\uAC00 \uCDE8\uC18C\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
  // Storage
  [STORAGE_ERROR_CODES.FILE_NOT_FOUND]: "\uD30C\uC77C\uC744 \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
  [STORAGE_ERROR_CODES.FILE_UPLOAD_FAILED]: "\uD30C\uC77C \uC5C5\uB85C\uB4DC\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4",
  [STORAGE_ERROR_CODES.FILE_TOO_LARGE]: "\uD30C\uC77C \uD06C\uAE30\uAC00 \uB108\uBB34 \uD07D\uB2C8\uB2E4",
  [STORAGE_ERROR_CODES.FILE_TYPE_NOT_ALLOWED]: "\uC9C0\uC6D0\uD558\uC9C0 \uC54A\uB294 \uD30C\uC77C \uD615\uC2DD\uC785\uB2C8\uB2E4",
  // Chat
  [CHAT_ERROR_CODES.CHAT_ROOM_NOT_FOUND]: "\uCC44\uD305\uBC29\uC744 \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
  [CHAT_ERROR_CODES.CHAT_ACCESS_DENIED]: "\uCC44\uD305\uBC29\uC5D0 \uC811\uADFC\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
  // Contract
  [CONTRACT_ERROR_CODES.CONTRACT_NOT_FOUND]: "\uACC4\uC57D\uC744 \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
  [CONTRACT_ERROR_CODES.CONTRACT_ALREADY_EXISTS]: "\uC774\uBBF8 \uC874\uC7AC\uD558\uB294 \uACC4\uC57D\uC785\uB2C8\uB2E4",
  // Validation
  [VALIDATION_ERROR_CODES.VALIDATION_FAILED]: "\uC785\uB825\uAC12 \uAC80\uC99D\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4",
  [VALIDATION_ERROR_CODES.REQUIRED_FIELD_MISSING]: "\uD544\uC218 \uC785\uB825\uAC12\uC774 \uB204\uB77D\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
  [VALIDATION_ERROR_CODES.INVALID_FORMAT]: "\uC62C\uBC14\uB974\uC9C0 \uC54A\uC740 \uD615\uC2DD\uC785\uB2C8\uB2E4",
  // General
  [GENERAL_ERROR_CODES.RESOURCE_NOT_FOUND]: "\uB9AC\uC18C\uC2A4\uB97C \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
  [GENERAL_ERROR_CODES.CONFLICT_ERROR]: "\uB370\uC774\uD130 \uCDA9\uB3CC\uC774 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4",
  // System
  [SYSTEM_ERROR_CODES.INTERNAL_SERVER_ERROR]: "\uC11C\uBC84 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4",
  [SYSTEM_ERROR_CODES.SERVICE_UNAVAILABLE]: "\uC11C\uBE44\uC2A4\uB97C \uC0AC\uC6A9\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
  [SYSTEM_ERROR_CODES.RATE_LIMIT_EXCEEDED]: "\uC694\uCCAD \uD55C\uB3C4\uB97C \uCD08\uACFC\uD588\uC2B5\uB2C8\uB2E4"
};
var getErrorMessage = (code) => {
  return ERROR_MESSAGES[code] || "\uC54C \uC218 \uC5C6\uB294 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4";
};

// src/constants/auth-validation.ts
var USER_ID_VALIDATION = {
  /** 최소 길이 */
  MIN_LENGTH: 4,
  /** 최대 길이 */
  MAX_LENGTH: 50,
  /** 정규표현식 (RegExp 객체) - 프론트엔드 react-hook-form용 */
  PATTERN: /^[a-zA-Z0-9_-]+$/,
  /** 정규표현식 (문자열) - 백엔드 class-validator용 */
  PATTERN_STRING: "^[a-zA-Z0-9_-]+$",
  /** 허용 문자 설명 */
  ALLOWED_CHARS: "\uC601\uBB38 \uB300\uC18C\uBB38\uC790, \uC22B\uC790, \uC5B8\uB354\uC2A4\uCF54\uC5B4(_), \uD558\uC774\uD508(-)"
};
var USER_ID_MESSAGES = {
  /** 필수 입력 */
  REQUIRED: "\uC544\uC774\uB514\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694",
  /** 최소 길이 미달 */
  MIN_LENGTH: "\uC544\uC774\uB514\uB294 \uCD5C\uC18C 4\uC790 \uC774\uC0C1\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4",
  /** 최대 길이 초과 */
  MAX_LENGTH: "\uC544\uC774\uB514\uB294 \uCD5C\uB300 50\uC790\uAE4C\uC9C0 \uAC00\uB2A5\uD569\uB2C8\uB2E4",
  /** 패턴 불일치 */
  PATTERN: "\uC544\uC774\uB514\uB294 \uC601\uBB38, \uC22B\uC790, \uC5B8\uB354\uC2A4\uCF54\uC5B4(_), \uD558\uC774\uD508(-)\uB9CC \uC0AC\uC6A9 \uAC00\uB2A5\uD569\uB2C8\uB2E4",
  /** 중복 */
  DUPLICATE: "\uC774\uBBF8 \uC0AC\uC6A9 \uC911\uC778 \uC544\uC774\uB514\uC785\uB2C8\uB2E4",
  /** 사용 가능 */
  AVAILABLE: "\uC0AC\uC6A9 \uAC00\uB2A5\uD55C \uC544\uC774\uB514\uC785\uB2C8\uB2E4"
};
var PASSWORD_VALIDATION = {
  /** 최소 길이 (OWASP 권장: 8자 이상) */
  MIN_LENGTH: 8,
  /** 최대 길이 (NIST 권장: 64자 이상 허용) */
  MAX_LENGTH: 64,
  /** 허용 특수문자 */
  SPECIAL_CHARS: "!$%&*?@",
  /**
   * 정규표현식 (RegExp 객체) - 프론트엔드 react-hook-form용
   * Industry Standard (OWASP/NIST): 소문자 + 숫자 + 특수문자 최소 필수
   * - 소문자 1개 이상 필수: (?=.*[a-z])
   * - 숫자 1개 이상 필수: (?=.*\d)
   * - 특수문자 1개 이상 필수: (?=.*[!$%&*?@])
   * - 허용 문자: 영문 소문자, 대문자, 숫자, 지정된 특수문자
   * Matches Supabase Auth password_requirements = "lower_upper_number_special" (대문자는 선택사항으로 유지)
   */
  PATTERN: /^(?=.*[a-z])(?=.*\d)(?=.*[!$%&*?@])[a-zA-Z\d!$%&*?@]+$/,
  /** 정규표현식 (문자열) - 백엔드 class-validator용 */
  PATTERN_STRING: "^(?=.*[a-z])(?=.*\\d)(?=.*[!$%&*?@])[a-zA-Z\\d!$%&*?@]+$",
  /** 허용 문자 설명 */
  ALLOWED_CHARS: "\uC601\uBB38 \uC18C\uBB38\uC790, \uC22B\uC790, \uD2B9\uC218\uBB38\uC790(!$%&*?@) (\uB300\uBB38\uC790\uB294 \uC120\uD0DD\uC0AC\uD56D)"
};
var PASSWORD_MESSAGES = {
  /** 필수 입력 */
  REQUIRED: "\uBE44\uBC00\uBC88\uD638\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694",
  /** 최소 길이 미달 */
  MIN_LENGTH: "\uBE44\uBC00\uBC88\uD638\uB294 \uCD5C\uC18C 8\uC790 \uC774\uC0C1\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4",
  /** 최대 길이 초과 */
  MAX_LENGTH: "\uBE44\uBC00\uBC88\uD638\uB294 \uCD5C\uB300 64\uC790\uAE4C\uC9C0 \uC785\uB825 \uAC00\uB2A5\uD569\uB2C8\uB2E4",
  /** 패턴 불일치 - 영문 소문자, 숫자, 특수문자 필수 */
  PATTERN: "\uC601\uBB38 \uC18C\uBB38\uC790, \uC22B\uC790, \uD2B9\uC218\uBB38\uC790\uB97C \uD3EC\uD568\uD574\uC57C \uD569\uB2C8\uB2E4",
  /** 확인 불일치 */
  CONFIRM_MISMATCH: "\uBE44\uBC00\uBC88\uD638\uAC00 \uC77C\uCE58\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4",
  /** 확인 일치 */
  CONFIRM_MATCH: "\uBE44\uBC00\uBC88\uD638\uAC00 \uC77C\uCE58\uD569\uB2C8\uB2E4",
  /** 확인 필수 입력 */
  CONFIRM_REQUIRED: "\uBE44\uBC00\uBC88\uD638 \uD655\uC778\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694"
};
var PHONE_VALIDATION = {
  /**
   * 한국 전화번호 패턴 (RegExp 객체) - 프론트엔드/백엔드 용
   *
   * 하이픈 옵션:
   * - 010-1234-5678 (하이픈 포함)
   * - 01012345678 (하이픈 미포함)
   * - 010-12345678 (하이픈 중간만)
   *
   * 패턴 설명:
   * ^                           # 문자열 시작
   * (?:
   *   0(?:[1][0-9]|[2-9]\d?)  # 휴대폰: 01[0-9] 또는 일반전화: 0[2-9]
   * )
   * (?:[-])?                   # 선택적 하이픈
   * \d{3,4}                     # 중간: 3~4자리
   * (?:[-])?                   # 선택적 하이픈
   * \d{4}$                      # 끝: 4자리 (문자열 끝)
   */
  PATTERN: /^0(?:[1][0-9]|[2-9]\d?)-?\d{3,4}-?\d{4}$/,
  /** 정규표현식 (문자열) - 백엔드 class-validator용 */
  PATTERN_STRING: "^0(?:[1][0-9]|[2-9]\\d?)-?\\d{3,4}-?\\d{4}$",
  /**
   * 엄격한 패턴: 하이픈 일관성 검증
   * - 010-1234-5678 (O)
   * - 01012345678 (O)
   * - 010-12345678 (X)
   * - 0101234-5678 (X)
   */
  PATTERN_STRICT: /^0(?:[1][0-9]|[2-9]\d?)(?:-\d{3,4}-\d{4}|\d{7,8})$/,
  PATTERN_STRICT_STRING: "^0(?:[1][0-9]|[2-9]\\d?)(?:-\\d{3,4}-\\d{4}|\\d{7,8})$",
  /** 휴대폰 번호만 (01[0-9]) */
  PATTERN_MOBILE: /^01[0-9]-?\d{3,4}-?\d{4}$/,
  PATTERN_MOBILE_STRING: "^01[0-9]-?\\d{3,4}-?\\d{4}$",
  /** 일반전화만 (02~09) */
  PATTERN_LANDLINE: /^0[2-9]\d?-?\d{3,4}-?\d{4}$/,
  PATTERN_LANDLINE_STRING: "^0[2-9]\\d?-?\\d{3,4}-?\\d{4}$",
  /** 최소 길이 (하이픈 없을 때: 10자) */
  MIN_LENGTH: 10,
  /** 최대 길이 (하이픈 포함: 13자) */
  MAX_LENGTH: 13,
  /** 허용 문자 */
  ALLOWED_CHARS: "\uC22B\uC790, \uD558\uC774\uD508(-)"
};
var PHONE_MESSAGES = {
  /** 필수 입력 */
  REQUIRED: "\uC5F0\uB77D\uCC98\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694",
  /** 패턴 불일치 */
  PATTERN: "\uC62C\uBC14\uB978 \uC804\uD654\uBC88\uD638 \uD615\uC2DD\uC774 \uC544\uB2D9\uB2C8\uB2E4 (\uC608: 010-1234-5678, 02-123-4567)",
  /** 휴대폰 패턴 불일치 */
  PATTERN_MOBILE: "\uC62C\uBC14\uB978 \uD734\uB300\uD3F0 \uBC88\uD638 \uD615\uC2DD\uC774 \uC544\uB2D9\uB2C8\uB2E4 (\uC608: 010-1234-5678)",
  /** 일반전화 패턴 불일치 */
  PATTERN_LANDLINE: "\uC62C\uBC14\uB978 \uC77C\uBC18\uC804\uD654 \uBC88\uD638 \uD615\uC2DD\uC774 \uC544\uB2D9\uB2C8\uB2E4 (\uC608: 02-123-4567)",
  /** 길이 오류 */
  INVALID_LENGTH: "\uC804\uD654\uBC88\uD638\uB294 10~13\uC790\uB9AC\uC5EC\uC57C \uD569\uB2C8\uB2E4"
};
var AUTH_VALIDATION = {
  USER_ID: USER_ID_VALIDATION,
  PASSWORD: PASSWORD_VALIDATION,
  PHONE: PHONE_VALIDATION
};
var AUTH_MESSAGES = {
  USER_ID: USER_ID_MESSAGES,
  PASSWORD: PASSWORD_MESSAGES,
  PHONE: PHONE_MESSAGES
};

// src/constants/mask.ts
var MASK_BAR_COLOR = "#F1F1F1";
var MASK_BAR_RADIUS = 99;
var MASK_BAR_WIDTH_PATTERN = [100, 68, 86, 100, 74];
function maskBarWidths(count) {
  return Array.from(
    { length: Math.max(0, count) },
    (_, i) => `${MASK_BAR_WIDTH_PATTERN[i % MASK_BAR_WIDTH_PATTERN.length]}%`
  );
}
var MASK_LOCK_GLYPH = {
  viewBox: "0 0 66 82",
  /** 상단 고리 (stroke) */
  shackle: "M15 36V21a18 18 0 0 1 36 0v15",
  shackleWidth: 9,
  /** 몸통 (fill) */
  body: { x: 0, y: 34, width: 66, height: 48, rx: 9 },
  /** 열쇠구멍 (배경색으로 파냄) */
  keyholeCircle: { cx: 33, cy: 53, r: 6 },
  keyholeStem: { x: 30, y: 55, width: 6, height: 14, rx: 3 }
};
var MASK_SCALE = {
  document: {
    barHeight: 50,
    gap: 40,
    paddingX: 20,
    paddingY: 30,
    lockWidth: 66,
    lockHeight: 82,
    lockGap: 19,
    fontSize: 28,
    lineHeight: 1.4,
    maxTextWidth: 294,
    /**
     * #F1F1F1 바 위에서 3.80:1 (바를 연하게 하기 전 #E6E6E6 에서는 3.44:1).
     * 28px 는 WCAG large text 라 기준이 3.0:1 이므로 통과한다.
     */
    textColor: "#7A7A7A"
  },
  compact: {
    barHeight: 18,
    gap: 14,
    paddingX: 0,
    paddingY: 16,
    lockWidth: 24,
    lockHeight: 30,
    lockGap: 8,
    fontSize: 13,
    lineHeight: 1.45,
    maxTextWidth: 240,
    /**
     * 13px 는 small text 라 기준이 4.5:1 로 올라간다.
     * #7A7A7A 는 #F1F1F1 위에서도 3.80:1 로 미달이라 #676767 (5.01:1) 로
     * 한 단계 어둡게 간다.
     */
    textColor: "#676767"
  }
};

// src/constants/bank-codes.ts
var POPBILL_BANK_CODES = {
  // 은행 (24개)
  KDB: "0002",
  // 산업은행
  IBK: "0003",
  // 기업은행
  KB: "0004",
  // 국민은행
  SUHYUP: "0007",
  // 수협은행
  NH: "0011",
  // 농협은행
  NH_LOCAL: "0012",
  // 농축협
  WOORI: "0020",
  // 우리은행
  SC: "0023",
  // SC제일은행
  CITY: "0027",
  // 씨티은행
  IM_BANK: "0031",
  // 아이엠뱅크 (구 대구은행)
  BUSAN: "0032",
  // 부산은행
  GWANGJU: "0034",
  // 광주은행
  JEJU: "0035",
  // 제주은행
  JEONBUK: "0037",
  // 전북은행
  GYEONGNAM: "0039",
  // 경남은행
  SAEMAUL: "0045",
  // 새마을금고
  SHINHYUP: "0048",
  // 신협중앙회
  SANLIM: "0064",
  // 산림조합중앙회
  POST: "0071",
  // 우체국
  HANA: "0081",
  // 하나은행
  SHINHAN: "0088",
  // 신한은행
  K_BANK: "0089",
  // 케이뱅크
  KAKAO: "0090",
  // 카카오뱅크
  TOSS: "0092",
  // 토스뱅크
  // 증권 (26개)
  YUANTA: "0209",
  // 유안타증권
  KB_SEC: "0218",
  // KB증권
  DAOL: "0227",
  // 다올투자증권
  MIRAE: "0238",
  // 미래에셋증권
  SAMSUNG: "0240",
  // 삼성증권
  KOREA_INVEST: "0243",
  // 한국투자증권
  NH_INVEST: "0247",
  // NH투자증권
  KYOBO: "0261",
  // 교보증권
  IM_INVEST: "0262",
  // 아이엠증권
  HYUNDAI_MOTOR: "0263",
  // 현대차증권
  KIWOOM: "0264",
  // 키움증권
  LS_INVEST: "0265",
  // LS증권
  SK_SEC: "0266",
  // SK증권
  DAISHIN: "0267",
  // 대신증권
  HANWHA: "0269",
  // 한화투자증권
  HANA_INVEST: "0270",
  // 하나금융투자
  TOSS_SEC: "0271",
  // 토스증권
  SHINHAN_INVEST: "0278",
  // 신한금융투자
  DB_INVEST: "0279",
  // DB금융투자
  EUGENE_INVEST: "0280",
  // 유진투자증권
  MERITZ: "0287",
  // 메리츠증권
  KAKAOPAY: "0288",
  // 카카오페이증권
  BOOKOOK: "0290",
  // 부국증권
  SHINYOUNG: "0291",
  // 신영증권
  CAPE: "0292",
  // 케이프투자증권
  WOORI_INVEST: "0294"
  // 우리투자증권
};
var BANK_LIST = [
  // 은행
  { code: "0002", name: "\uC0B0\uC5C5\uC740\uD589" },
  { code: "0003", name: "\uAE30\uC5C5\uC740\uD589" },
  { code: "0004", name: "\uAD6D\uBBFC\uC740\uD589" },
  { code: "0007", name: "\uC218\uD611\uC740\uD589" },
  { code: "0011", name: "\uB18D\uD611\uC740\uD589" },
  { code: "0012", name: "\uB18D\uCD95\uD611" },
  { code: "0020", name: "\uC6B0\uB9AC\uC740\uD589" },
  { code: "0023", name: "SC\uC81C\uC77C\uC740\uD589" },
  { code: "0027", name: "\uC528\uD2F0\uC740\uD589" },
  { code: "0031", name: "\uC544\uC774\uC5E0\uBC45\uD06C" },
  { code: "0032", name: "\uBD80\uC0B0\uC740\uD589" },
  { code: "0034", name: "\uAD11\uC8FC\uC740\uD589" },
  { code: "0035", name: "\uC81C\uC8FC\uC740\uD589" },
  { code: "0037", name: "\uC804\uBD81\uC740\uD589" },
  { code: "0039", name: "\uACBD\uB0A8\uC740\uD589" },
  { code: "0045", name: "\uC0C8\uB9C8\uC744\uAE08\uACE0" },
  { code: "0048", name: "\uC2E0\uD611\uC911\uC559\uD68C" },
  { code: "0064", name: "\uC0B0\uB9BC\uC870\uD569\uC911\uC559\uD68C" },
  { code: "0071", name: "\uC6B0\uCCB4\uAD6D" },
  { code: "0081", name: "\uD558\uB098\uC740\uD589" },
  { code: "0088", name: "\uC2E0\uD55C\uC740\uD589" },
  { code: "0089", name: "\uCF00\uC774\uBC45\uD06C" },
  { code: "0090", name: "\uCE74\uCE74\uC624\uBC45\uD06C" },
  { code: "0092", name: "\uD1A0\uC2A4\uBC45\uD06C" },
  // 증권
  { code: "0209", name: "\uC720\uC548\uD0C0\uC99D\uAD8C" },
  { code: "0218", name: "KB\uC99D\uAD8C" },
  { code: "0227", name: "\uB2E4\uC62C\uD22C\uC790\uC99D\uAD8C" },
  { code: "0238", name: "\uBBF8\uB798\uC5D0\uC14B\uC99D\uAD8C" },
  { code: "0240", name: "\uC0BC\uC131\uC99D\uAD8C" },
  { code: "0243", name: "\uD55C\uAD6D\uD22C\uC790\uC99D\uAD8C" },
  { code: "0247", name: "NH\uD22C\uC790\uC99D\uAD8C" },
  { code: "0261", name: "\uAD50\uBCF4\uC99D\uAD8C" },
  { code: "0262", name: "\uC544\uC774\uC5E0\uC99D\uAD8C" },
  { code: "0263", name: "\uD604\uB300\uCC28\uC99D\uAD8C" },
  { code: "0264", name: "\uD0A4\uC6C0\uC99D\uAD8C" },
  { code: "0265", name: "LS\uC99D\uAD8C" },
  { code: "0266", name: "SK\uC99D\uAD8C" },
  { code: "0267", name: "\uB300\uC2E0\uC99D\uAD8C" },
  { code: "0269", name: "\uD55C\uD654\uD22C\uC790\uC99D\uAD8C" },
  { code: "0270", name: "\uD558\uB098\uAE08\uC735\uD22C\uC790" },
  { code: "0271", name: "\uD1A0\uC2A4\uC99D\uAD8C" },
  { code: "0278", name: "\uC2E0\uD55C\uAE08\uC735\uD22C\uC790" },
  { code: "0279", name: "DB\uAE08\uC735\uD22C\uC790" },
  { code: "0280", name: "\uC720\uC9C4\uD22C\uC790\uC99D\uAD8C" },
  { code: "0287", name: "\uBA54\uB9AC\uCE20\uC99D\uAD8C" },
  { code: "0288", name: "\uCE74\uCE74\uC624\uD398\uC774\uC99D\uAD8C" },
  { code: "0290", name: "\uBD80\uAD6D\uC99D\uAD8C" },
  { code: "0291", name: "\uC2E0\uC601\uC99D\uAD8C" },
  { code: "0292", name: "\uCF00\uC774\uD504\uD22C\uC790\uC99D\uAD8C" },
  { code: "0294", name: "\uC6B0\uB9AC\uD22C\uC790\uC99D\uAD8C" }
];
var BANK_NAME_MAP = BANK_LIST.reduce(
  (acc, curr) => ({ ...acc, [curr.code]: curr.name }),
  {}
);
var POPBILL_RESULT_CODES = {
  /** 성공 (과금) */
  SUCCESS: "100",
  /** 확인불가 (과금) */
  INVALID_ACCOUNT: "300",
  // 금융기관 미등록 계좌번호
  ID_MISMATCH: "301",
  // 계좌번호와 실명번호 불일치
  RESTRICTED_ACCOUNT: "400",
  // 거래 제한된 계좌번호
  BANK_MAINTENANCE_API: "801",
  // 금융기관 시스템 점검중
  RESULT_NOT_PROVIDED: "898",
  // 금융기관 결과 미제공
  OTHER_ERROR: "899",
  // 기타 오류
  /** 실패 (미과금) */
  SCHEDULED_MAINTENANCE: "201",
  // 금융기관 시스템 정기점검 시간 (23:30~00:30)
  INVALID_FORMAT: "202",
  // 유효하지 않은 계좌번호
  FOREIGN_ACCOUNT: "204",
  // 외환계좌 지원 불가
  UNSUPPORTED_BANK: "206",
  // 지원되지 않는 금융기관
  SYSTEM_ERROR: "998"
  // 금융기관 시스템 장애
};
var POPBILL_RESULT_MESSAGES = {
  [POPBILL_RESULT_CODES.SUCCESS]: "\uC131\uACF5",
  [POPBILL_RESULT_CODES.INVALID_ACCOUNT]: "\uAE08\uC735\uAE30\uAD00\uC5D0 \uB4F1\uB85D\uB418\uC9C0 \uC54A\uC740 \uACC4\uC88C\uBC88\uD638\uC785\uB2C8\uB2E4.",
  [POPBILL_RESULT_CODES.ID_MISMATCH]: "\uACC4\uC88C\uBC88\uD638\uC640 \uC2E4\uBA85\uC815\uBCF4\uAC00 \uC77C\uCE58\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.",
  [POPBILL_RESULT_CODES.RESTRICTED_ACCOUNT]: "\uAC70\uB798\uAC00 \uC81C\uD55C\uB41C \uACC4\uC88C\uBC88\uD638\uC785\uB2C8\uB2E4.",
  [POPBILL_RESULT_CODES.BANK_MAINTENANCE_API]: "\uD574\uB2F9 \uAE08\uC735\uAE30\uAD00 \uC2DC\uC2A4\uD15C \uC810\uAC80 \uC911\uC785\uB2C8\uB2E4.",
  [POPBILL_RESULT_CODES.RESULT_NOT_PROVIDED]: "\uAE08\uC735\uAE30\uAD00\uC5D0\uC11C \uACB0\uACFC\uB97C \uC81C\uACF5\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.",
  [POPBILL_RESULT_CODES.OTHER_ERROR]: "\uAE30\uD0C0 \uC870\uD68C \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4.",
  [POPBILL_RESULT_CODES.SCHEDULED_MAINTENANCE]: "\uAE08\uC735\uAE30\uAD00 \uC815\uAE30 \uC810\uAC80 \uC2DC\uAC04(23:30~00:30)\uC785\uB2C8\uB2E4.",
  [POPBILL_RESULT_CODES.INVALID_FORMAT]: "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uACC4\uC88C\uBC88\uD638 \uD615\uC2DD\uC785\uB2C8\uB2E4.",
  [POPBILL_RESULT_CODES.FOREIGN_ACCOUNT]: "\uC678\uD658\uACC4\uC88C\uB294 \uC870\uD68C\uAC00 \uBD88\uAC00\uB2A5\uD569\uB2C8\uB2E4.",
  [POPBILL_RESULT_CODES.UNSUPPORTED_BANK]: "\uC9C0\uC6D0\uB418\uC9C0 \uC54A\uB294 \uAE08\uC735\uAE30\uAD00\uC785\uB2C8\uB2E4.",
  [POPBILL_RESULT_CODES.SYSTEM_ERROR]: "\uAE08\uC735\uAE30\uAD00 \uC2DC\uC2A4\uD15C \uC7A5\uC560\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4."
};
export {
  AUTH_ERROR_CODES,
  AUTH_MESSAGES,
  AUTH_VALIDATION,
  BANK_LIST,
  BANK_NAME_MAP,
  CHAT_ERROR_CODES,
  CONTRACT_ERROR_CODES,
  ERROR_CODES,
  ERROR_MESSAGES,
  GENERAL_ERROR_CODES,
  MASK_BAR_COLOR,
  MASK_BAR_RADIUS,
  MASK_LOCK_GLYPH,
  MASK_SCALE,
  PASSWORD_MESSAGES,
  PASSWORD_VALIDATION,
  PAYMENT_ERROR_CODES,
  PHONE_MESSAGES,
  PHONE_VALIDATION,
  POPBILL_BANK_CODES,
  POPBILL_RESULT_CODES,
  POPBILL_RESULT_MESSAGES,
  QUOTE_ERROR_CODES,
  STORAGE_ERROR_CODES,
  SYSTEM_ERROR_CODES,
  USER_ERROR_CODES,
  USER_ID_MESSAGES,
  USER_ID_VALIDATION,
  VALIDATION_ERROR_CODES,
  getErrorMessage,
  maskBarWidths
};
//# sourceMappingURL=index.mjs.map